/**
 * Class that will render the fields.
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Render = (function (){

        /**
         * Verify the field type and render it.
         *
         * @param {object} selectedItem with a field structure
         * @returns {object} a Monet.UI.Fields object
         * @constructor
         */

        function FieldsRender (selectedItem, entity, options) {

            const type = (options && options.behaveAs) ? options.behaveAs : selectedItem.type;
            let field = null;

            const configurePickList = function (pickListType){
                field = new Monet.UI.Fields[pickListType](selectedItem, entity);
                field.setEntity(entity);
                field.setFieldId(selectedItem.id);
                field.setDisplayKey(selectedItem.lookupEntityColumn);
                let lookupEntity = selectedItem.lookupEntity;

                if(lookupEntity && typeof lookupEntity === 'object'){
                    lookupEntity = lookupEntity.key;
                }

                field.setLookUpEntity(lookupEntity);
                field.setDefaultValue(selectedItem.defaultValue || ' ');
                field.setFieldDomains(selectedItem.fieldDomains);
                field.setIfIsAReactField(selectedItem.isAReactField);

                doDefaultActions();
            };

            var configurePriorityQueue = function (_field){

                _field.setFieldId(selectedItem.id);
                doDefaultActions();
            };

            this.setCustomNameSpace = function (customNamespace) {
                entity = customNamespace;
            };

            const getFormattedFieldId = ()=>  {
                return entity ? `${entity}_${selectedItem.name}` : selectedItem.name;
            };

            const doDefaultActions = () => {
                field.setMeta(selectedItem.meta);
                field.setEntity(entity);
                field.setMaxSize(selectedItem.maxSize);

                field.render();
                field.setId(getFormattedFieldId());
                field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                field.setInputName(selectedItem.name);
                field.setMandatory(selectedItem.mandatory);

                if (typeof(selectedItem.defaultValue) !== "undefined"){
                    field.setDefaultValue(selectedItem.defaultValue);
                }
                field.setOptions(selectedItem.meta);

            };

            const doToggleNumberActions = (toggleType) => {

                field = new Monet.UI.Fields[toggleType]();

                field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));

                if(selectedItem.meta && typeof selectedItem.meta === 'string') {
                    const complementLabel = JSON.parse(selectedItem.meta).complementLabel;
                    field.setTextComplementLabel(Monet.I18n.getResourcesByKey(complementLabel));
                }

                doDefaultActions();
            };

            const configureLookup = (lookupType) => {

                let lookupEntity = selectedItem.lookupEntity
                    ,name = selectedItem.name
                    ,nameSpace =  `${name[0].toUpperCase()}${name.substring(1)}Lookup`
                    ,layoutNamespace ;

                if (lookupEntity && typeof lookupEntity === 'object'){
                    lookupEntity = lookupEntity.key;
                }

                layoutNamespace = `Lookup${lookupEntity[0].toUpperCase()}${lookupEntity.substring(1)}`
                field = new Monet.UI.Fields[lookupType]();
                field.setNameSpace(entity + nameSpace);
                field.setLayoutNameSpace( layoutNamespace );
                field.setLookUpEntity(lookupEntity);
                field.setDisplayKey(selectedItem.lookupEntityColumn);

                doDefaultActions();
            };

            const configureTimeHour = () => {
              field = new Monet.UI.Fields.TimeHoursSecondsField();
              field.setMeta(options);
              doDefaultActions();
            };

            const configureRadioGroup = () => {
              if(options && options.isFilterBuilder) {
                  configurePickList('PickList');
              } else {
                  field = new Monet.UI.Fields.RadioGroup();
                  field.setId(selectedItem.id);
                  field.setFieldDomains(selectedItem.fieldDomains);
                  field.setMeta(selectedItem.meta);
                  field.setEntity(entity);
                  field.setMaxSize(selectedItem.maxSize);
                  field.render();
                  field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                  field.setInputName(selectedItem.name);
                  field.setMandatory(selectedItem.mandatory);

                  if(selectedItem.defaultValue){
                      field.setDefaultValue(selectedItem.defaultValue);
                  }
              }
          }

            this.render = function () {

                const basicRender = (monetType) => {
                    field = new Monet.UI.Fields[monetType]();
                    doDefaultActions();
                };
                const types = {
                     "FILE": () => basicRender('File')
                    ,"IMAGE_UPLOAD": () => basicRender('ImageUpload')
                    ,"MULTIPLE_IMAGE_UPLOAD": () => basicRender('MultipleImageUpload')
                    ,"MULTIPLE_FILES_ATTACHMENTS": () => basicRender('MultipleFilesAttachments')
                    ,"TEXT": () => basicRender('TextField')
                    ,"DATE": () => basicRender('DateField')
                    ,"DATE_RANGE": () => basicRender('DateRange')
                    ,"DATE_TIME": () => basicRender('DateTimeField')
                    ,"DATE_TIME_RANGE": () => basicRender('DateTimeRange')
                    ,"EMAIL": () => basicRender('Email')
                    ,"PHONE": () => basicRender('Phone')
                    ,"LAT_LONG": () => basicRender('LatLong')
                    ,"DECIMAL": () => basicRender('Decimal')
                    ,"DECIMAL_RANGE": () => basicRender('DecimalRange')
                    ,"DECIMAL_RATE_KM": () => basicRender('DecimalRateKm')
                    ,"DISTANCE": () => basicRender('Distance')
                    ,"COMPARE_NUMBER": () => basicRender('CompareNumber')
                    ,"INTEGER": () => basicRender('Number')
                    ,"INTEGER_RANGE": () => basicRender('NumberRange')
                    ,"MILES_OR_METERS": () => basicRender('MileOrMeters')
                    ,"MILES_OR_KM": () => basicRender('MilesOrKilometers')
                    ,"METERS_OR_FEET": () => basicRender('Distance')
                    ,"CHECKBOX": () => basicRender('Checkbox')
                    ,"TIME": () => basicRender('TimeField')
                    ,"TIME_SECONDS": () => basicRender('TimeSecondsField')
                    ,"TIME_MINUTES": () => basicRender('TimeMinutesField')
                    ,"TIME_MINUTES_SECONDS": () => basicRender('TimeMinutesSecondsField')
                    ,"TIME_HOURS_SECONDS": () => {

                      if (options) {
                        configureTimeHour()
                      } else {
                        basicRender('TimeHoursSecondsField')
                      }
                    }
                    ,"TIME_RANGE": () => basicRender('TimeRange')
                    ,"TIME_LENGTH": () => basicRender('TimeLength')
                    ,"ICON": () => basicRender('Icon')
                    ,"TAG_FILTER": () => basicRender('TagFilter')
                    ,"SECONDS": () => basicRender('Seconds')
                    ,"SECONDS_RANGE": () => basicRender('SecondsRange')
                    ,"PASSWORD": () => basicRender('Password')
                    ,"ICON_PICKER": () => basicRender('IconPicker')
                    ,"TEXT_AREA": () => basicRender('TextArea')
                    ,"REPETITION": () => basicRender('Repetition')

                    ,"LOOKUP": () => configureLookup('PowerLookup')
                    ,"LOOKUP_LIST": () => configureLookup('PowerLookupList')
                    ,"POWER_LOOKUP_LIST_FILTER": () => configureLookup('PowerLookupListFilter')

                    ,"PICKLIST": () => configurePickList('PickList')
                    ,"PICKLIST_AUTOCOMPLETE": () => configurePickList('PickListAutoComplete')
                    ,"PICKLIST_MULTISELECT": () => configurePickList('PickListMultiselect')
                    ,"PICKLIST_MULTISELECT_FILTER": () => configurePickList('PickListMultiselectFilter')

                    ,"TOGGLENUMBER": () => doToggleNumberActions('ToggleNumber')
                    ,"TOGGLENUMBER_RANGE": () => doToggleNumberActions('NumberRange')

                    ,"BUTTON": () => {
                        var customJavaScript = selectedItem.customJavaScript;
                        field = new Monet.UI.Fields.Button();
                        field.render();
                        field.setDefaultValue(selectedItem.defaultValue);
                        field.setValue(Monet.I18n.getResourcesByKey(selectedItem.label));
                        field.setMeta(selectedItem.meta);
                        field.removeClickEventListener(customJavaScript);
                        field.addEventClickListener(customJavaScript);
                        field.setId(getFormattedFieldId());
                    }
                    ,"LIST_BOX": () => {
                        if(options && options.isFilterBuilder) {
                            configureLookup('PowerLookup')
                        } else {
                            field = new Monet.UI.Fields.ListBox();

                            let lookupEntity = selectedItem.lookupEntity;
                            if(lookupEntity && typeof lookupEntity === 'object'){
                                lookupEntity = lookupEntity.key;
                            }
                            field.setListingEntity(lookupEntity);

                            doDefaultActions();
                        }
                    }
                    ,"COLOR": () => {
                        field = new Monet.UI.Fields.ColorPicker(options);
                        field.setMeta(selectedItem.meta);
                        field.render();
                        field.setDefaultValue(selectedItem.defaultValue);
                        field.setId(getFormattedFieldId());
                        field.setColor(selectedItem.color);
                        field.setMandatory(selectedItem.mandatory);
                        field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                    }
                    ,"TAG": () => {
                        field = new Monet.UI.Fields.Tag();
                        field.setEntity(entity);
                        field.render();
                        field.setDefaultValue(selectedItem.defaultValue);
                        field.setId(getFormattedFieldId());
                        field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                        field.setInputName(selectedItem.name);
                        field.setMandatory(selectedItem.mandatory);
                    }
                    ,"RADIO": () => {
                        field = new Monet.UI.Fields.Radio();
                        doDefaultActions();
                        field.setValue(selectedItem.value);
                        if ( selectedItem.id ) {
                            field.setInputId(selectedItem.id);
                        }
                    }
                    ,"LINK": () => {
                        field = new Monet.UI.Fields.Link();
                        field.setId(getFormattedFieldId());

                        field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                        field.setInputName(selectedItem.name);
                        field.setMandatory(selectedItem.mandatory);
                        field.setEntity(entity);
                        field.setMeta(selectedItem.meta);

                        if(selectedItem.defaultValue){
                            field.setDefaultValue(selectedItem.defaultValue);
                        }
                        field.render();
                    }
                    ,"HIDDEN": () => {
                        field = new Monet.UI.Fields.TextField();
                        doDefaultActions();
                        field.rootEl.setAttribute("style","display: none");
                    }
                    ,"TEXT_AREA_ATTRIBUTES": () => {
                        if(options && options.isFilterBuilder) {
                            basicRender('TextField');
                        } else {
                            basicRender('TextAreaAttributes')
                        }
                    }
                    ,"TEXT_EDITOR_ATTRIBUTES": () => {
                        if(options && options.isFilterBuilder) {
                            basicRender('TextField');
                        } else {
                            basicRender('TextEditorAttributes')
                        }
                    }
                    ,"RADIOGROUP": configureRadioGroup
                    ,"RADIO_GROUP": configureRadioGroup
                    ,"CHECKBOX_GROUP": () => {
                        if(options && options.isFilterBuilder) {
                            configurePickList('PickList');
                        } else {
                            field = new Monet.UI.Fields.CheckboxGroup();
                            field.setId(selectedItem.id);
                            field.setFieldDomains(selectedItem.fieldDomains);
                            field.setMeta(selectedItem.meta);
                            field.setEntity(entity);
                            field.setMaxSize(selectedItem.maxSize);
                            field.render();
                            field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                            field.setInputName(selectedItem.name);
                            field.setMandatory(selectedItem.mandatory);

                            if(selectedItem.defaultValue){
                                field.setDefaultValue(selectedItem.defaultValue);
                            }
                        }
                    }
                    ,"RATING": () => {
                        field = new Monet.UI.Fields.Rating();
                        field.render();
                    }
                    ,"PICKLIST_ICON": () => {
                      field = new Monet.UI.Fields.PickListIcon(selectedItem, entity);
                      field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                      field.render();
                    }
                    ,"PRIORITY_QUEUE": () => {
                      field = new Monet.UI.Fields.PriorityQueue();
                      configurePriorityQueue(field);
                    },
                    "SWITCH": () => {
                        field = new Monet.UI.Fields.Switch();
                        if (selectedItem.label) {
                            field.setCheckedLabel(selectedItem.label);
                            field.setUncheckedLabel(selectedItem.label);
                            field.setInputName(selectedItem.name);
                        }
                        doDefaultActions();

                    },
                    "CUSTOM_TAG": () => {
                      field = new Monet.UI.Fields.CustomTag();
                      field.setId(getFormattedFieldId());
                      field.setEntity(selectedItem.lookupEntity);
                      field.setEntityColumn(selectedItem.lookupEntityColumn);
                      field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                      field.setInputName(selectedItem.name);
                      field.render();
                    },
                    "MULTIPLE_FIELDS": () => {
                      field = new Monet.UI.Fields.MultipleFields();
                      field.setId(getFormattedFieldId());
                      field.setMandatory(selectedItem.mandatory);
                      field.setTextLabel(Monet.I18n.getResourcesByKey(selectedItem.label));
                      field.setInputName(selectedItem.name);
                      field.setFields(selectedItem.fields)
                      field.render();
                    }
                };
                const fieldConstructionFunction = types[type];
                fieldConstructionFunction ? fieldConstructionFunction() : types.TEXT();

                return field;
            };

        }

    return FieldsRender;

}());
